module.exports = __webpack_public_path__ + "static/media/file-icon.1430fb29.svg";